<free-bets-header
  [licenseType]="globalVars.LICENSE_TYPE"
  [forbiddenFreebets]="forbiddenFreebets"
  (onChangeHeader)="onChangeHeader($event)"
/>
<ion-content padding class="background-color-muted">
  <free-bets-verification
    *ngIf="forbiddenFreebets"
    [phoneNumber]="phoneNumber"
    [freeBetSMSVerification]="globalVars.FEATURES.FreeBetSMSVerification"
    [freeBetAccountVerification]="globalVars.FEATURES.FreeBetAccountVerification"
    [isMobile]="isMobile"
    (update)="updateData()"
  />
  <free-bets-info
    *ngIf="!forbiddenFreebets && showFbOnline"
    [aPendingFB]="aPendingFBOnline"
    [activeFB]="activeFBOnline"
    [licenseType]="globalVars.LICENSE_TYPE"
    [firstLoad]="firstLoad"
    [isMobile]="isMobile"
    [isFbOnline]="true"
  />
  <free-bets-info
    *ngIf="!forbiddenFreebets && showFbLocal"
    [aPendingFB]="aPendingFBLocal"
    [activeFB]="activeFBLocal"
    [licenseType]="globalVars.LICENSE_TYPE"
    [firstLoad]="firstLoad"
    [isMobile]="isMobile"
    [isFbOnline]="false"
  />
</ion-content>
